// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logship-body {
  padding: 0 24px 24px;
}

.logship-subtitle {
  margin: 0 0 1rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.logship-checked {
  white-space: nowrap;
}

.logship-legend {
  display: flex;
  gap: 0.75rem;
  font-size: 0.78rem;
  color: #6b7280;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.dot {
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background: #9ca3af;
  flex: 0 0 auto;
}

.dot-healthy {
  background: #16a34a;
}

.dot-warning {
  background: #f59e0b;
}

.dot-stale {
  background: #dc2626;
}

.dot-none {
  background: #9ca3af;
}

.dot-info {
  background: #7c3aed;
}

.logship-state {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 0.5rem;
  color: #6b7280;
  font-size: 0.9rem;
}

.logship-state-error {
  color: #b91c1c;
}

.logship-table-wrap {
  overflow-x: auto;
}

.logship-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.logship-table th,
.logship-table td {
  text-align: left;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}
.logship-table th {
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
}

.company-cell {
  font-weight: 500;
}

.status-pill,
.stage-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
}

.status-healthy {
  background: #ecfdf5;
  color: #065f46;
}

.status-warning {
  background: #fffbeb;
  color: #92400e;
}

.status-stale {
  background: #fef2f2;
  color: #991b1b;
}

.status-none {
  background: #f3f4f6;
  color: #6b7280;
}

.status-info {
  background: #f5f3ff;
  color: #5b21b6;
}

.stage-cell {
  vertical-align: top;
  min-width: 180px;
}

.cell-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.stage-age {
  font-variant-numeric: tabular-nums;
}

.stage-failing {
  color: #b91c1c;
  font-size: 0.75rem;
}

.file-status {
  padding: 0.05rem 0.4rem;
  border-radius: 4px;
  font-size: 0.7rem;
  background: #f3f4f6;
  color: #4b5563;
}

.file-status-loaded {
  background: #ecfdf5;
  color: #065f46;
}

.file-status-partial {
  background: #fffbeb;
  color: #92400e;
}

.file-status-failed {
  background: #fef2f2;
  color: #991b1b;
}

.file-status-scored {
  background: #f5f3ff;
  color: #5b21b6;
}

.cell-file {
  max-width: 240px;
  margin-top: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  color: #4b5563;
}

.cell-file-info {
  color: #6d28d9;
}

.more-btn {
  margin-top: 0.2rem;
  padding: 0;
  font-size: 0.78rem;
}

.not-available {
  color: #9ca3af;
  font-size: 0.8rem;
  font-style: italic;
}

.more-note {
  margin: 0 0 0.75rem;
  color: #6b7280;
  font-size: 0.85rem;
}

.more-table .cell-file {
  max-width: 320px;
}

.expect-not_expected td,
.expect-retired td {
  color: #9ca3af;
}

.more-table td.row-status {
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/admin-dashboard/logship-status.component.scss"],"names":[],"mappings":"AAGA;EACE,oBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAKA;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EAAe,mBAAA;AADf;;AAEA;EAAe,mBAAA;AAEf;;AADA;EAAe,mBAAA;AAKf;;AAJA;EAAe,mBAAA;AAQf;;AALA;EAAe,mBAAA;AASf;;AAPA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AAUF;;AAPA;EACE,cAAA;AAUF;;AAPA;EACE,gBAAA;AAUF;;AAPA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAUF;AARE;;EAEE,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;AAUJ;AAPE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AASJ;;AALA;EACE,gBAAA;AAQF;;AALA;;EAEE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAQF;;AALA;EAAkB,mBAAA;EAAqB,cAAA;AAUvC;;AATA;EAAkB,mBAAA;EAAqB,cAAA;AAcvC;;AAbA;EAAkB,mBAAA;EAAqB,cAAA;AAkBvC;;AAjBA;EAAkB,mBAAA;EAAqB,cAAA;AAsBvC;;AArBA;EAAkB,mBAAA;EAAqB,cAAA;AA0BvC;;AAxBA;EACE,mBAAA;EACA,gBAAA;AA2BF;;AAxBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AA2BF;;AAxBA;EACE,kCAAA;AA2BF;;AAxBA;EACE,cAAA;EACA,kBAAA;AA2BF;;AAvBA;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA0BF;;AAvBA;EAAuB,mBAAA;EAAqB,cAAA;AA4B5C;;AA3BA;EAAuB,mBAAA;EAAqB,cAAA;AAgC5C;;AA/BA;EAAuB,mBAAA;EAAqB,cAAA;AAoC5C;;AAnCA;EAAuB,mBAAA;EAAqB,cAAA;AAwC5C;;AAtCA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAyCF;;AAtCA;EACE,cAAA;AAyCF;;AAtCA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAyCF;;AAtCA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAyCF;;AAtCA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAyCF;;AAtCA;EACE,gBAAA;AAyCF;;AAtCA;;EAEE,cAAA;AAyCF;;AAtCA;EACE,mBAAA;AAyCF","sourcesContent":["// The shell is the portal-wide .table-wrapper / .table-header pattern (see styles.scss), so the\n// title, reload control and card chrome match every other table page. Only the pieces unique to\n// this view are styled here.\n.logship-body {\n  padding: 0 24px 24px;\n}\n\n.logship-subtitle {\n  margin: 0 0 1rem;\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.logship-checked {\n  white-space: nowrap;\n}\n\n.logship-legend {\n  display: flex;\n  gap: 0.75rem;\n  font-size: 0.78rem;\n  color: #6b7280;\n}\n\n.legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.dot {\n  display: inline-block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  background: #9ca3af;\n  flex: 0 0 auto;\n}\n\n.dot-healthy { background: #16a34a; }\n.dot-warning { background: #f59e0b; }\n.dot-stale   { background: #dc2626; }\n.dot-none    { background: #9ca3af; }\n// ioIQ is informational, with no freshness health: violet, a colour used nowhere else on the\n// page, instead of a traffic-light colour or the grey of \"never\".\n.dot-info    { background: #7c3aed; }\n\n.logship-state {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1.5rem 0.5rem;\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.logship-state-error {\n  color: #b91c1c;\n}\n\n.logship-table-wrap {\n  overflow-x: auto;\n}\n\n.logship-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n\n  th,\n  td {\n    text-align: left;\n    padding: 0.6rem 0.75rem;\n    border-bottom: 1px solid #e5e7eb;\n    white-space: nowrap;\n  }\n\n  th {\n    font-weight: 600;\n    color: #374151;\n    background: #f9fafb;\n  }\n}\n\n.company-cell {\n  font-weight: 500;\n}\n\n.status-pill,\n.stage-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.status-healthy { background: #ecfdf5; color: #065f46; }\n.status-warning { background: #fffbeb; color: #92400e; }\n.status-stale   { background: #fef2f2; color: #991b1b; }\n.status-none    { background: #f3f4f6; color: #6b7280; }\n.status-info    { background: #f5f3ff; color: #5b21b6; }\n\n.stage-cell {\n  vertical-align: top;\n  min-width: 180px;\n}\n\n.cell-top {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.stage-age {\n  font-variant-numeric: tabular-nums;\n}\n\n.stage-failing {\n  color: #b91c1c;\n  font-size: 0.75rem;\n}\n\n// Loaded / skipped / failed, next to ETL's age: arriving and being ingested are not the same thing.\n.file-status {\n  padding: 0.05rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.file-status-loaded  { background: #ecfdf5; color: #065f46; }\n.file-status-partial { background: #fffbeb; color: #92400e; }\n.file-status-failed  { background: #fef2f2; color: #991b1b; }\n.file-status-scored  { background: #f5f3ff; color: #5b21b6; }\n\n.cell-file {\n  max-width: 240px;\n  margin-top: 0.3rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.75rem;\n  color: #4b5563;\n}\n\n.cell-file-info {\n  color: #6d28d9;\n}\n\n.more-btn {\n  margin-top: 0.2rem;\n  padding: 0;\n  font-size: 0.78rem;\n}\n\n.not-available {\n  color: #9ca3af;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n.more-note {\n  margin: 0 0 0.75rem;\n  color: #6b7280;\n  font-size: 0.85rem;\n}\n\n.more-table .cell-file {\n  max-width: 320px;\n}\n\n.expect-not_expected td,\n.expect-retired td {\n  color: #9ca3af;\n}\n\n.more-table td.row-status {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
